/**
 * schemas/auth.ts — เข้าสู่ระบบและจัดการผู้ใช้
 */
import { z } from 'zod';
import { USER_ROLES } from '../constants.js';
import { optionalText, requiredText } from './common.js';
export const MIN_PASSWORD_LENGTH = 8;
export const password = z
    .string()
    .min(MIN_PASSWORD_LENGTH, `รหัสผ่านต้องยาวอย่างน้อย ${MIN_PASSWORD_LENGTH} ตัวอักษร`)
    .max(128, 'รหัสผ่านยาวเกินไป');
export const loginSchema = z.object({
    username: requiredText('ชื่อผู้ใช้', 100),
    password: z.string().min(1, 'กรุณากรอกรหัสผ่าน'),
});
export const refreshSchema = z.object({
    /** mobile ส่ง refresh token มาใน body; web ใช้ cookie */
    refreshToken: z.string().min(1).optional(),
});
export const createUserSchema = z.object({
    username: requiredText('ชื่อผู้ใช้', 100).regex(/^[a-zA-Z0-9._-]+$/, 'ชื่อผู้ใช้ใช้ได้เฉพาะ a-z 0-9 . _ -'),
    password,
    displayName: optionalText(200),
    role: z.enum(USER_ROLES).default('user'),
});
export const updateUserSchema = z.object({
    displayName: optionalText(200).optional(),
    role: z.enum(USER_ROLES).optional(),
    password: password.optional(),
    active: z.boolean().optional(),
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1, 'กรุณากรอกรหัสผ่านปัจจุบัน'),
    newPassword: password,
});
//# sourceMappingURL=auth.js.map